<template>
  <Section tone="default" pad-y="lg">
    <Container narrow>
      <Breadcrumbs :items="items" />
      <header class="mt-6 flex flex-col gap-3">
        <h1 class="text-3xl font-extrabold tracking-tight text-ink-strong md:text-4xl">
          {{ t('pages.privacy.heading') }}
        </h1>
        <p class="text-base text-ink-muted md:text-lg">{{ t('pages.privacy.lead') }}</p>
      </header>
      <ProseSection class="mt-8" :aria-label="t('pages.privacy.heading')">
        <h2>{{ t('pages.privacy.content.main.title') }}</h2>
        <p>
          <strong>{{ t('pages.privacy.content.main.companyName') }}</strong>
        </p>
        <ul>
          <li>
            <strong>{{ t('pages.privacy.content.main.inn') }}:</strong> 7735164826
          </li>
          <li>
            <strong>{{ t('pages.privacy.content.main.kpp') }}:</strong> 772201001
          </li>
          <li>
            <strong>{{ t('pages.privacy.content.main.ogrn') }}:</strong> 1177746828236
          </li>
          <li>
            <strong>{{ t('pages.privacy.content.main.opd') }}:</strong> 77-17-008439
          </li>
          <li>
            <strong>{{ t('pages.privacy.content.main.duns') }}:</strong> 522553043
          </li>
        </ul>
        <h2>{{ t('pages.privacy.content.address.title') }}</h2>
        <p>
          <strong>{{ t('pages.privacy.content.address.subtitle') }}:</strong>
        </p>
        <p>{{ t('pages.privacy.content.address.address') }}</p>
        <h2>{{ t('pages.privacy.content.openingHours.title') }}</h2>
        <p>
          <strong>{{ t('pages.privacy.content.openingHours.openingHours') }}</strong>
        </p>
        <h2>{{ t('pages.privacy.content.contacts.title') }}</h2>
        <p>
          Email: <a href="mailto:sales@bafsy.com">sales@bafsy.com</a>
          <br />
          VK: <a href="https://vk.com/bafsypromo" target="_blank">https://vk.com/bafsypromo</a>
        </p>
        <h2>{{ t('pages.privacy.content.achievements.title') }}</h2>
        <ul>
          <li>
            <strong>{{ t('pages.privacy.content.achievements.gost') }} P ISO 9001:2015</strong> —
            <a href="/docs/bafsy_iso.pdf" target="_blank">{{
              t('pages.privacy.content.achievements.labelCertificate')
            }}</a
            >.
          </li>
          <li>
            <strong>{{ t('pages.privacy.content.achievements.event1.title') }}</strong> —
            <a href="https://arppsoft.ru/members/12992/" target="_blank">{{
              t('pages.privacy.content.achievements.event1.labelCard')
            }}</a
            >,
            <a href="/docs/certificate.pdf" target="_blank">{{
              t('pages.privacy.content.achievements.event1.lableCertificate')
            }}</a
            >.
          </li>
          <li>
            <strong>{{ t('pages.privacy.content.achievements.event2.title') }}</strong
            >.
          </li>
          <li>
            {{ t('pages.privacy.content.achievements.event3.titleBegin') }}
            <strong>{{ t('pages.privacy.content.achievements.event3.title') }}</strong>
            {{ t('pages.privacy.content.achievements.event3.titleEnd') }}
          </li>
        </ul>
        <h2>{{ t('pages.privacy.content.legals.title') }}</h2>
        <ul>
          <li>
            <a href="/docs/personal_data.pdf" target="_blank">{{
              t('pages.privacy.content.legals.lebalPersonalData')
            }}</a>
          </li>
          <li>
            <a href="/docs/policy.pdf" target="_blank">{{
              t('pages.privacy.content.legals.lebalPolicy')
            }}</a>
          </li>
        </ul>
        <p>{{ t('pages.privacy.content.copyright') }}</p>
      </ProseSection>
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import Breadcrumbs from '@/components/navigation/Breadcrumbs.vue';
import ProseSection from '@/components/utility/ProseSection.vue';
import { useLocale } from '@/composables/useLocale';
import { useSeo } from '@/composables/useSeo';

const { t } = useI18n();
const { locale } = useLocale();

useSeo({
  title: t('pages.privacy.heading'),
  description: t('pages.privacy.lead'),
  noindex: true,
});

const items = computed(() => [
  { label: t('breadcrumbs.home'), to: `/${locale.value}/` },
  { label: t('nav.privacy') },
]);
</script>
